import {useEffect, useState} from "react";
import "./MainDashboard.scss";
import MyOrders from "./MyOrders/MyOrders.jsx";
import OrderCodeSection from "./OrderCodeSection/OrderCodeSection.jsx";
import DashboardTitleType from "./DashboardTitleType/DashboardTitleType.jsx";
import imageChicken from "../../../../Assets/images/Group 2.png";
import axios from "axios";
import {prefixUrl} from "../../../../Utils/utilsData";
import Loader from "../../../Loader/Loader";
import {toast} from "react-toastify";

// Sample data for MainDashboard

const MainDashboard = () => {
  const [initialData, setInitialData] = useState({});
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    axios
      .get(`${prefixUrl()}/user/dashboard.php`)
      .then((response) => {
        if (response.data.status) {
          setInitialData(response.data.output)
          setIsLoad(true)
        } else {
          toast.error("خطا در بر قراری ارتباط")
        }
      });
  }, []);

  return (
    <>
      {isLoad ?
        <div className="main-dashboard">
          <div>
            <DashboardTitleType title={"سفارش‌های من"}/>
            <MyOrders
              numberOfComments={initialData?.numberOfComments}
              numberOfPurchases={initialData?.numberOfPurchases}
              totalPurchaseAmount={initialData?.totalPurchaseAmount}
            />
          </div>
          {initialData?.lastOrder?.length > 0 ? (
            initialData?.lastOrder.map((v) =>
              <div>
                <OrderCodeSection initialData={v}/>
              </div>
            )
          ) : (
            <div style={{paddingTop: "50px"}}>سفارشی نداشته اید</div>
          )}
        </div>
        : <Loader/>}
    </>
  );
};

export default MainDashboard;
